import { BotServiceClient } from '@/src/shared/services/api.services';
import { BOT_SERVICE_API_URLS } from '@/src/shared/services/endpoints/externalApiUrls';
import { appendParamsToUrl, replaceParamsInUrl } from '@/src/utils/urlUtil';

import type {
    AssistantMessageFeedback,
    BaseChatMessage,
    ChatApiPayload,
    GetConversationHistoryPayload,
    GetConversationSummaryPayload,
    GetConversationSummaryResponse,
    SetFeedbackPayload,
} from '../../types';

export const chatApi = async (payload: ChatApiPayload) => {
    const response = await BotServiceClient.post(BOT_SERVICE_API_URLS.CHAT, payload, {
        adapter: 'fetch',
        responseType: 'stream',
    });
    return response;
};

export const getConversationSummaries = async (payload: GetConversationSummaryPayload) => {
    const res = await BotServiceClient.get<GetConversationSummaryResponse>(
        appendParamsToUrl('/api/conversations/multi-read', payload)
    );
    return res.data;
};

export const getConversationHistory = async (payload: GetConversationHistoryPayload) => {
    const res = await BotServiceClient.get<BaseChatMessage[]>(
        appendParamsToUrl('/api/conversations/:conversationId/history', payload)
    );
    return res.data;
};

export const deleteConversations = async (conversationIds: string[]) => {
    const res = await BotServiceClient.post('/api/conversations/multi-delete', { conversationIds });
    return res.data;
};

export const setFeedback = async (payload: SetFeedbackPayload) => {
    const res = await BotServiceClient.post<AssistantMessageFeedback>(
        ...replaceParamsInUrl(
            '/api/conversations/:conversationId/activity/:activityId/feedback',
            payload
        )
    );
    return res.data;
};
